import { SIGNUP_URL } from '../config';

interface Props {
  mobileMenuOpen: boolean;
  onToggleMenu: () => void;
}

interface NavLink {
  href: string;
  label: string;
  isCTA?: boolean;
  isExternal?: boolean;
}

const navLinks: NavLink[] = [
  { href: '/#features', label: 'Features' },
  { href: '/#compare', label: 'Compare' },
  { href: '/#pricing', label: 'Pricing' },
  { href: '/#install', label: 'Local' },
  { href: 'https://github.com/ThatCatDev/tanrenai', label: 'GitHub', isExternal: true },
  { href: SIGNUP_URL, label: 'Sign Up', isCTA: true, isExternal: true },
];

function Header({ mobileMenuOpen, onToggleMenu }: Props) {
  return (
    <nav class="fixed top-0 left-0 right-0 z-[100] bg-[oklch(10%_0.012_250/_0.8)] backdrop-blur-[20px] border-b border-border">
      <div class="max-w-[var(--max-width-content)] mx-auto px-[var(--spacing-gutter)] h-16 flex items-center justify-between">
        <a href="/" class="flex items-center gap-2.5 font-display font-bold text-[1.15rem] tracking-[-0.02em] text-fg hover:no-underline">
          <img src="/logo.png" alt="TanrenAI" class="h-8 w-8" />
          <span>TanrenAI</span>
        </a>
        <div
          class={`items-center gap-8 ${
            mobileMenuOpen
              ? 'flex flex-col absolute top-16 left-0 right-0 bg-[oklch(12%_0.012_250/_0.97)] backdrop-blur-[20px] py-6 px-[var(--spacing-gutter)] border-b border-border gap-4'
              : 'hidden md:flex'
          }`}
        >
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              target={link.isExternal ? '_blank' : undefined}
              rel={link.isExternal ? 'noopener' : undefined}
              class={
                link.isCTA
                  ? 'bg-accent text-white font-semibold text-[0.8rem] px-[1.2em] py-[0.5em] rounded-lg transition-all duration-200 hover:bg-accent-dim hover:no-underline hover:shadow-[0_0_20px_var(--accent-glow)]'
                  : 'text-muted text-[0.875rem] font-medium transition-colors duration-200 hover:text-fg hover:no-underline'
              }
              onClick={(e: Event) => {
                if (link.isExternal) return;
                // Anchor links are written as "/#section". If that section
                // exists on the current page, smooth-scroll to it; otherwise
                // let the browser navigate home (e.g. from /support).
                const hash = link.href.startsWith('/#') ? link.href.slice(1) : link.href;
                const target = hash.startsWith('#') ? document.querySelector(hash) : null;
                if (target) {
                  e.preventDefault();
                  target.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              {link.label}
            </a>
          ))}
        </div>
        <button
          class="md:hidden bg-transparent border-0 cursor-pointer w-8 h-8 flex flex-col justify-center items-center gap-[5px]"
          aria-label="Menu"
          onClick={onToggleMenu}
        >
          <span class="block w-5 h-[2px] bg-fg rounded-sm transition-transform duration-300" />
          <span class="block w-5 h-[2px] bg-fg rounded-sm transition-transform duration-300" />
          <span class="block w-5 h-[2px] bg-fg rounded-sm transition-transform duration-300" />
        </button>
      </div>
    </nav>
  );
}

export default Header;
